<template>
    <div id="travel-page">
        <Card title="Travel">
            <template #description>
                <p>
                    I am based at the University of Toronto. Below is an account
                    of places I will be in a professional capacity.
                </p>
                <b>2026</b>
                <ul>
                    <li><b>July 6th to 10th</b>: The Max Planck Institute.</li>

                    <li>
                        <b>June 29th to July 3rd</b>: Homotopy Theory, Derived
                        Categories, and Quadratic Forms at Université d'Artois.
                    </li>
                    <li>
                        <b>June 22nd to 26th</b>: European Talbot in Kolding,
                        Denmark.
                    </li>
                    <li>
                        <b>June 8th to 12th</b>: Homotopy Theory, K-theory, and
                        Topological Data Analysis at Western University.
                    </li>
                    <li>
                        <b>March 15th to 18th</b>: FRG Workshop on Higher
                        Categories and Geometry in Chicago.
                    </li>
                </ul>

                <b>2025</b>
                <ul>
                    <li>
                        <b>October 24th to 26th</b>: Equivariant, Motivic, and
                        Physical Topology in the Midwest at the University of
                        Minnesota.
                    </li>
                    <li>
                        <b>October 20th to 22nd</b>: The University of
                        Regensburg.
                    </li>
                    <li>
                        <b>October 6th to 10th</b>: Young Homotopy Theorists
                        Meeting at the International Centre for Mathematical
                        Sciences.
                    </li>
                    <li>
                        <b>May 19th to 23rd</b>: K-Theory in Symplectic Topology
                        at Woods Hole Marine Biological Research Laboratory.
                    </li>
                </ul>
            </template>
        </Card>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Card from "@/components/Card.vue";
import Hairline from "@/components/Hairline.vue";

export default defineComponent({
    components: { Card, Hairline },
});
</script>

<style lang="scss">
@use "@/assets/global";

#travel-page {
    margin-left: global.$side-margin-width;
    margin-right: global.$side-margin-width;
    margin-bottom: global.$top-margin-width;
}
</style>
